module.exports = __webpack_public_path__ + "static/media/greenz.d265f3aa.webp";